export default __webpack_public_path__ + "static/media/create-place-showcase.fa53906b.jpg";